<template>
	<div
		class="post-pinterest"
		@click="$emit('click')"
	>
		<helio-icon
			token="pinterest-p"
			weight="brand"
		/>
	</div>
</template>
<script>
import Icon from '../../icon/Icon.vue';

export default {
	components: {
		'helio-icon': Icon,
	},
};
</script>

<style lang="scss" src="./post-pinterest.scss" />
